"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CALENDAR_UPDATE = 'CALENDAR_UPDATE';
exports.CALENDAR_NO_SUBSCRIPTION = 'NO_SUBSCRIPTION';
exports.EVENT_TIME_DEFAULT = 0;
exports.CALENDAR_UPDATE_INTERVAL = 10 * 1000; // Update calendar every 10 seconds
